<template>
  <div class="add-c-example">
    <span class="add-c-example-title">示例</span>
    <div class="add-c-example-content">
      <span class="add-c-example-content-label" :title="exampleName?exampleName:'字段名称'">{{exampleName?exampleName:"字段名称"}}</span>
      <!-- 文本框示例 -->
      <el-input
        size='small'
        v-model="text"
        v-if="nowCustomType===1 || nowCustomType===3"
        placeholder="请输入"
        readonly
        class="add-c-example-content-value"
      >
      </el-input>
      <!-- 日期示例 -->
      <el-date-picker
        v-model="date"
        type="date"
        size='small'
        readonly
        class="add-c-example-content-value"
        v-if="nowCustomType===2"
        placeholder="选择日期">
      </el-date-picker>
      <!-- 下拉选项 -->
      <el-select
        v-model="select"
        placeholder="请选择"
        size='small'
        clearable
        class="add-c-example-content-value"
        v-if="nowCustomType===4"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <!-- 上传图片 -->
      <span  class="add-c-example-content-value" v-if="nowCustomType===5" title="示例上传仅做展示,没有上传功能">
        <i class="el-icon-plus"></i>
        <span>上传图片</span>
      </span>
      <!-- 按钮 -->
      <span class="add-c-example-content-value" v-if="nowCustomType===6">
        <span
          v-for="i in 3"
          :key="i"
          class="add-c-example-content-value-minBtn"
          @click="nowBtn = i"
          :class="{ 'add-c-example-content-value-active':i ===nowBtn }"
        >
          {{'按钮'+i}}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    props:{
      nowCustomType:{
        type:[Number,String],
        default:1  // 默认文本框
      },
      exampleName:{
       type:[Number,String],
       default:"字段名字"  // 默认文本框
      }
    },
    data() {
      return {
        nowBtn:1,
        text:"",
        date:new Date(),
        select:'',
        options: [{
          value: '选项1',
          label: '示例一'
        }, {
          value: '选项2',
          label: '示例二'
        }, {
          value: '选项3',
          label: '示例三'
        }, {
          value: '选项4',
          label: '示例四'
        }, {
          value: '选项5',
          label: '示例五'
        }]
      }
    }
  }
</script>

<style lang='less' scoped>

</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/dialogComponents/add-c-example.vue